module.exports = __webpack_public_path__ + "media/images/bg-W-opaque-655b952f047d6c5c3570e90f90d3aa6e.svg";